/*
    常用方法集合
 */
// import wx from '@tencent/ppd-base-libs/wx/wx-sdk';
import {
  request,
} from '@tencent/ppd-base-libs';
const jsApiList = ['closeWindow', 'hideOptionMenu', 'showOptionMenu', 'hideMenuItems', 'showMenuItems', 'updateTimelineShareData', 'updateAppMessageShareData'];
const openTagList = ['wx-open-launch-weapp', 'wx-open-subscribe'];
const sdk = {
  initFlag: false,
  queue: [],
  sdkReady: false,
  callMyself: false,
  runQueue() {
    let item;
    while ((item = this.queue.shift())) {
      this.runSDK(item.name, item.paramObj, item.fn);
    }
  },
  setConfig(json) {
    wx.config({
      beta: true,
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: json.appId, // 必填，公众号的唯一标识
      timestamp: json.timeStamp, // 必填，生成签名的时间戳
      nonceStr: json.nonceStr, // 必填，生成签名的随机串
      signature: json.signature, // 必填，签名，见附录1
      jsApiList, // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      openTagList, // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
    });
    wx.ready(() => {
      this.sdkReady = true;
      this.initFlag = false;
      this.runQueue();
    });
    wx.error((res) => {
      console.warn(res.errMsg || 'jssdk初始化失败');
      this.initFlag = false;
    });
  },
  initCfg(json) {
    if (this.sdkReady) {
      return;
    }
    this.callMyself = true;
    this.setConfig(json);
  },
  init() {
    if (this.initFlag) return;
    if (this.sdkReady) {
      this.runQueue();
      return;
    }
    this.initFlag = true;
    const params = {
      url: location.href.split('#')[0],
      app_name: 'hk_life',
    };
    request.get('/app/promotion/appid_jsapi_signature.cgi', {
      params,
    }).then((res) => {
      if (!res || res.retcode !== '0') {
        return;
      }
      if (this.callMyself) {
        return;
      }
      sdk.setConfig(res);
    });
  },
  runSDK(name, paramObj, fn) {
    if (wx[name]) {
      wx[name](paramObj);
    } else {
      wx.invoke(name, paramObj, fn || ((res) => { }));
    }
  },
  invoke(name, paramObj, fn) {
    const queueItem = {};
    if (sdk.sdkReady) {
      sdk.runSDK(name, paramObj, fn);
    } else {
      queueItem.name = name;
      queueItem.paramObj = paramObj;
      queueItem.fn = fn;
      sdk.queue.push(queueItem);
      sdk.init(paramObj);
    }
  },
};

export default {
  init: sdk.init,
  share({
    imgUrl,
    url,
    title,
    desc,
    success,
  }) {
    const config = {
      img_url: imgUrl,
      imgUrl,
      img_width: '240',
      img_height: '240',
      link: url || location.href,
      desc: desc || document.title,
      title: title || document.title,
      success(res) {
        let msg = '';
        if (res) {
          if (res.errMsg) {
            msg = res.errMsg;
          }
        }
        if (success) {
          success(/:ok$/.test(msg));
        }
      },
    };
    sdk.invoke('updateAppMessageShareData', config);
    sdk.invoke('updateTimelineShareData', config);
  },
  postMsg(data) {
    return wx.miniProgram.postMessage(data);
  },
  showOptionMenu() {
    sdk.invoke('showOptionMenu');
  },
  hideOptionMenu() {
    sdk.invoke('hideOptionMenu');
  },
  invoke: sdk.invoke,
  runSDK: sdk.runSDK,
};
